import React from "react";
import PageTitle from "../../../components/pagetitle/PageTitle";

const Jenjangofl25 = () => {
  return (
    <>
      <PageTitle
        menuback="Category Page"
        backbtn="/kategori25"
        motherMenu="List of Winners Offline"
        activeMenu="/ 2025"
      />

      <section className="faq-section">
        <div className="container text-center">
          <h1>
            Choose based on the Level of the Offline event you are participating
            in
          </h1>
          <div className="hero-btn text-center">
            <a
              className="btn m-2"
              href="https://drive.google.com/file/d/1U02IdiQkVtS1DNFbH0nows6tfwQmQKTF/view?usp=sharing"
              target="_blank"
              rel="noreferrer"
            >
              University
            </a>
            <a
              className="btn m-2"
              href="https://drive.google.com/file/d/1_MKV1bkx-sv66Ffdi6pjHmsGoCi226Xb/view?usp=sharing"
              target="_blank"
              rel="noreferrer"
            >
              Senior High School
            </a>
            <a
              className="btn m-2"
              href="https://drive.google.com/file/d/1obELlNFKo41GTL6s6179FUTnmAYu3EwO/view?usp=sharing"
              target="_blank"
              rel="noreferrer"
            >
              Junior High School
            </a>
            <a
              className="btn m-2"
              href="https://drive.google.com/file/d/1JoJbhnbO_qIDqO0pv19Vs4m9oEsQu85o/view?usp=sharing"
              target="_blank"
              rel="noreferrer"
            >
              Elementary School
            </a>
          </div>
        </div>
      </section>
    </>
  );
};

export default Jenjangofl25;
